<template>
  <div>
    <div class="colspan clearfix">
      <h2>{{decumentInfo.title}}</h2>
      <div>
        <span>{{$dateToConver(decumentInfo.publish_at)}}</span>
        <i v-if="decumentInfo.page_view"
           class="el-icon-view"></i>
        <span>{{decumentInfo.page_view}}</span>
      </div>

      <el-carousel v-if="decumentInfo.type==2"
                   :interval="5000"
                   arrow="always"
                   height="350px"
                   class="lbFather"
                   style="width:580px;margin-top:30px">
        <el-carousel-item :key="index"
                          v-for="(item,index) in decumentInfo.subsidiary_files">
          <img v-lazy="item.pub_file_text.url"
               class="lubotu">
        </el-carousel-item>
      </el-carousel>
      <div v-if="decumentInfo.type==3 "
           :key="index"
           v-for="(item,index) in decumentInfo.subsidiary_files"
           style="margin-top:30px">
        <iframe height=420
                width=850
                :src='item.code_url'
                frameborder=0></iframe>
      </div>
      <p v-html="decumentInfo.content"
         style="min-height:500px"></p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    detailData: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      decumentInfo: {},   //新闻详情
      isPic: false,
    }
  },

  created () {

  },
  methods: {

  },
  watch: {
    detailData (newValue, oldValue) {
      this.decumentInfo = newValue
      if (this.decumentInfo.type == 4) {
        if (this.decumentInfo.content) {
          window.open(this.decumentInfo.content, '_blank');

          if (this.$route.query.preview == 1) {
            this.$router.push({ path: '/' })
          } else {
            this.$router.go(-1)
          }
        }

      }
    },
  },

}
</script>
<style lang="less" scoped>
.head-box {
  color: #888888;
  text-align: center;
  padding-bottom: r(40);
  > h2 {
    color: #404040;
    font-weight: normal;
    // text-align: center
  }
  > span {
    font-size: r(32);
  }
}
.colspan {
  width: 950px;
  min-height: 500px;
  overflow: hidden;
  background-color: #ffffff;
  border: solid 1px #e5e5e5;
  box-sizing: border-box;
  padding: 0 20px;
  > h2 {
    text-align: center;
  }
  > div {
    text-align: center;
    font-size: 16px;
    color: #888;
    > span:nth-of-type(1) {
      margin-right: 30px;
    }
  }
  .lbFather {
    position: relative;
    text-align: center;
    margin: 0 auto;
  }
  .lubotu {
    color: #333;
    width: 100%;
    height: 100%;
  }
  /deep/img {
    max-width: 100% !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/overView/rightContent.vue